var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_8330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_8330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 8.25C13.9087 8.25 15.7917 8.633 17.6487 9.399C19.5057 10.165 21.1311 11.2756 22.5247 12.7308C22.7311 12.9373 22.8359 13.1786 22.8392 13.4548C22.8424 13.7311 22.7407 13.9693 22.5342 14.1693L20.6285 16.025C20.426 16.2212 20.1991 16.3308 19.9477 16.3538C19.6966 16.3769 19.4646 16.3103 19.2517 16.1537L16.7362 14.2422C16.5709 14.1166 16.4485 13.9775 16.369 13.825C16.2895 13.6725 16.2497 13.5001 16.2497 13.3078V10.4865C15.5267 10.2417 14.8222 10.0577 14.1362 9.9345C13.4504 9.8115 12.7382 9.75 11.9997 9.75C11.2612 9.75 10.5491 9.8115 9.86323 9.9345C9.17723 10.0577 8.47273 10.2417 7.74973 10.4865V13.3078C7.74973 13.5001 7.70998 13.6725 7.63048 13.825C7.55098 13.9775 7.42856 14.1166 7.26323 14.2422L4.74773 16.1537C4.53489 16.3103 4.30289 16.3769 4.05173 16.3538C3.80039 16.3308 3.57348 16.2212 3.37098 16.025L1.46523 14.1693C1.25873 13.9693 1.15706 13.7311 1.16023 13.4548C1.16356 13.1786 1.26839 12.9373 1.47473 12.7308C2.85806 11.2756 4.48081 10.165 6.34298 9.399C8.20514 8.633 10.0907 8.25 11.9997 8.25Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call_end.00d2c28e4eeb6e7edd2e0ada12fca34b.svg";
export { ForwardRef as ReactComponent };